const authTypes = {
    CLEAR_AUTH: '[AUTH] CLEAR_AUTH',
    SET_CORPORATE_ENTITY_DATA: '[AUTH] SET_CORPORATE_ENTITY_DATA',
    SET_COUNTRY_DATA: '[AUTH] SET_COUNTRY_DATA',
    SET_GROUP_DATA: '[AUTH] SET_GROUP_DATA',
    SET_LEARNING_COMMUNITY_DATA: '[AUTH] SET_LEARNING_COMMUNITY_DATA',
    SET_MENU: '[AUTH] SET_MENU',
    SET_PROFILE_DATA: '[AUTH] SET_PROFILE_DATA',
    SET_REGIONAL_ENTITY_DATA: '[AUTH] SET_REGIONAL_ENTITY_DATA',
    SET_ROLE_DATA: '[AUTH] SET_ROLE_DATA',
};
export default authTypes;
